import {Component, inject} from '@angular/core';
import {GridPageComponent, FilterConfig} from "../../common/grid-page.component";
import {StorageType, HalbGridViewDto} from "@services";
import EnumUtils from "../../../shared/enum-utils";
import {CommonModule} from "@angular/common";
import {
    DxDataGridComponent,
    DxFormComponent,
    DxTemplateDirective
} from "devextreme-angular";
import {
    DxiColumnComponent,
    DxiItemComponent,
    DxoColumnChooserComponent,
    DxoExportComponent,
    DxoFilterRowComponent,
    DxoHeaderFilterComponent,
    DxoLoadPanelComponent,
    DxoPagerComponent,
    DxoPagingComponent,
    DxoPositionComponent,
    DxoScrollingComponent,
    DxoSearchComponent,
    DxoSearchPanelComponent,
    DxoSelectionComponent,
    DxoSortingComponent,
    DxoToolbarComponent
} from "devextreme-angular/ui/nested";
import {FilterPanelComponent} from "../../../components/library/filter-panel/filter-panel.component";
import {Router, RouterLink} from "@angular/router";
import {DxDataGridTypes} from "devextreme-angular/ui/data-grid";

@Component({
    selector: 'app-halbs',
    imports: [
        CommonModule,
        DxDataGridComponent,
        DxiColumnComponent,
        DxoHeaderFilterComponent,
        DxTemplateDirective,
        DxiItemComponent,
        DxoColumnChooserComponent,
        DxoExportComponent,
        DxoLoadPanelComponent,
        DxoSearchPanelComponent,
        DxoSortingComponent,
        DxoToolbarComponent,
        DxoPagingComponent,
        DxoPagerComponent,
        DxoFilterRowComponent,
        DxFormComponent,
        FilterPanelComponent,
        DxoPositionComponent,
        DxoSearchComponent,
        DxoSelectionComponent,
        DxoScrollingComponent,
        RouterLink,
    ],
    templateUrl: './halbs.component.html',
    styleUrl: './halbs.component.scss',
})
export class HalbsComponent extends GridPageComponent<HalbGridViewDto> {
    private router = inject(Router);

    constructor() {
        super();
        this.init(HalbGridViewDto);
    }

    dataSource = this.dataSources.halbs();

    binTypeOptions = EnumUtils.getEnumOptions(StorageType);

    protected override exportName: string = "Halbs";

    protected override filterConfig: FilterConfig[] = [
        {field: 'number', op: 'contains'},
        {field: 'description', op: 'contains'},
        {field: 'materialType', op: 'contains'},
        {field: 'mdrRecordOwner', op: 'contains'},
        {field: 'imspShared', op: 'contains'},
        {field: 'fullPallet', op: '>='},
        {field: 'revisedStorageType', op: '='},
        {field: 'materialGroup', op: 'contains'}
    ];

    override async onRowDblClick(e: DxDataGridTypes.RowDblClickEvent) {
        const {data} = e;
        await this.router.navigate([`/inventory/halb/details/${data.number}`]);
    }
}

